import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo, references } from '@apexdesigner/schema-tools';

export const processUserInterfaceProperty = z
  .object({
    id: z.uuid().hidden().describe('Unique identifier'),

    name: z
      .string()
      .nullable()
      .optional()
      .requiredFinal()
      .describe('Property name'),

    isArray: z
      .boolean()
      .nullable()
      .optional()
      .describe('Whether this is an array'),

    isInput: z
      .boolean()
      .nullable()
      .optional()
      .describe('Data passed into the component'),

    isOutput: z
      .boolean()
      .nullable()
      .optional()
      .describe('Data produced by the component'),

    required: z
      .boolean()
      .nullable()
      .optional()
      .describe('Whether a value is required'),

    description: z
      .string()
      .nullable()
      .optional()
      .presentAs('textarea')
      .describe('Description'),

    sequence: z
      .number()
      .nullable()
      .optional()
      .hidden()
      .describe('Display order'),

    userInterfaceId: z
      .uuid()
      .hidden()
      .describe('Foreign key to ProcessUserInterface'),

    typeId: z
      .uuid()
      .nullable()
      .optional()
      .presentAs('reference')
      .describe('Foreign key to ProcessDataType'),

    userInterface: belongsTo('ProcessUserInterface'),

    type: references('ProcessDataType'),
  })
  .describe(
    'An input or output property on a process user interface component.',
  )
  .as('ProcessUserInterfaceProperty');

export { processUserInterfaceProperty as processUserInterfacePropertySchema };
